


import React from "react";
import { Row, Col, MenuItem, Nav, Navbar, NavItem, NavDropdown, Button, Panel, Grid, DropdownButton, FormGroup, FormControl } from 'react-bootstrap'
import InputNumber from 'rc-input-number';
import 'rc-input-number/assets/index.css';
class Quantity extends React.Component {
    render() {
        return (

            <div className="cart__quantity cell">
                <div>
                    <InputNumber
                        min={1}
                        max={10}
                        onChange={this.props.onChange}
                        defaultValue={1}
                        value={this.props.value}
                    />
                </div>
            </div>


        );
    }
}
export default Quantity;





// WEBPACK FOOTER //
// ./src/Components/Quantity/Quantity.jsx